import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { APIService, KPI } from '../../@core/api';

@Injectable()
export class QuantityUnitsService {

  private _quantityUnits$: Observable<KPI.QuantityUnit[]>;

  constructor(
    private api: APIService,
  ) { }

  public get quantityUnits$(): Observable<KPI.QuantityUnit[]> {
    if (!this._quantityUnits$) {
      this._quantityUnits$ = this.api.assets_quantity_units(null, false);
    }

    return this._quantityUnits$;
  }

}
